<template>
    <el-dialog title="明细" :visible.sync="dialogVisible" width="70%">
        <div class="barcode-merge">
            <m-table
                ref="RegistrationTable"
                :pageTotal="pageTotal"
                :tableData="listData"
                :config="tableConfig"
                @pageChange="pageChange"
                @sizeChange="sizeChange"
                @search="searchChange"
                @onSearchDataChange="onSearchDataChange">
            </m-table>
        </div>
    </el-dialog>
</template>
<script>
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { tableConfig } from './tableConfig.js';
import { executeStatusDetail } from '@/modules/sn/api/lcbsManagement.js';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
export default {
    name: 'detail',
    components: { mTable },
    data() {
        return {
            dialogVisible: false,
            tableConfig,
            searchData: {
                batchId: ''
            },
            listData: [],
            pageTotal: 0
        };
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    methods: {
        onSearchDataChange(data) {
            this.searchData = {
                batchId: this.searchData.batchId,
                ...data
            };
        },
        open(batchId) {
            if (this.$refs.RegistrationTable) this.$refs.RegistrationTable.restSearchForm();
            this.searchData = {
                batchId
            };
            this.dialogVisible = true;
            this.searchChange();
        },
        searchChange() {
            this.tableConfig.page.pageNo = 1;
            this.getData(this.searchData);
        },
        getData(data) {
            const params = {
                param: cloneDeep(data),
                tenantCode: this.currentTenant.tenantCode
            };
            params.param.pageSize = this.tableConfig.page.pageSize;
            params.param.pageNo = this.tableConfig.page.pageNo;
            this.listData = [];
            executeStatusDetail(params).then((res) => {
                if (res.code + '' === '0' && res.data) {
                    this.pageTotal = res.data.totalCount;
                    this.listData = res.data.list.map(item => {
                        item.processFlag = item.processFlag === 'Y' ? '是' : '否';
                        item.successFlag = item.successFlag === 'Y' ? '是' : '否';
                        return item;
                    });
                }
            });
        },

        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.getData(this.searchData);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.getData(this.searchData);
        }
    }
};
</script>
<style lang="less" scoped>
.barcode-merge {
    /deep/ .nPanel-1 .el-table {
        height: 400px !important;
    }
}
</style>